
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.512 2.527l.098.035.106.058.083.064 1.385 1.238 1.384-1.238a.716.716 0 01.68-.153l.101.037.097.052.083.064 1.387 1.24 1.386-1.225c.159-.14.369-.202.573-.174l.101.02.1.037c.188.085.329.245.391.448l.025.105.008.104v11.424a2.751 2.751 0 01-2.59 2.743l-.067.001-9.692.003A2.756 2.756 0 012.52 14.99l-.015-.162-.005-.164v-1.31c0-.322.213-.6.523-.69l.096-.023.102-.007h1.646V3.239a.72.72 0 01.25-.545l.083-.062.092-.05a.72.72 0 01.596.003l.094.05.084.064 1.385 1.224 1.387-1.24a.72.72 0 01.674-.156zm3.537 1.66l-1.385 1.24a.72.72 0 01-.78.115l-.098-.052-.083-.064L9.32 4.188 7.934 5.426a.72.72 0 01-.778.118l-.097-.052-.083-.063-.667-.59v7.794h6.417c.322 0 .6.213.692.523l.021.096.008.102v1.309a1.307 1.307 0 002.59.243l.016-.123.005-.12V4.839l-.666.59a.72.72 0 01-.78.113l-.095-.052-.083-.064-1.385-1.238zm-1.044 9.887H3.94v.589c0 .635.46 1.172 1.063 1.284l.123.016.12.006h7.089l-.014-.025a2.735 2.735 0 01-.287-.88l-.022-.188-.008-.213v-.589zm2.102-4.257a.721.721 0 01.198 1.413l-.096.021-.102.008H8.278a.721.721 0 01-.197-1.412l.095-.022.102-.008h5.829zm-2.51-2.51a.721.721 0 01.197 1.412l-.096.022-.102.007H8.278a.72.72 0 01-.197-1.412l.095-.022.102-.008h3.318z"}})])
          )
        }
      }
    